
(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npAnchor', function () {
        return {
            restrict: 'E',
            replace: true,
            controller: ['$scope', '$location', 'browserService', controller],
            template: '<a href="{{anchor}}" target="_self" title="{{anchorName}}"> {{anchorName}} </a>',
            scope: {
                anchorPrefix: '=',
                anchorId: '=',
                anchorName: '='
            }
        };
    });

    function controller($scope, $location, browserService) {
        var anchor = $scope.anchorPrefix + $scope.anchorId;
        if (browserService.historyManipulationSupported()) {
            anchor = $location.path() + window.location.search + anchor;
        }

        $scope.anchor = anchor;
    }
})();